import React from 'react';
import { getTextColor } from '../../../lib/composer/schemas/theme';
import { textColorClassMap } from '@osmosis/tailwind-ui/styles/text';
import clsx from 'clsx';
import { P } from '@osmosis/tailwind-ui/components/Text';
import { HeaderProps } from '../../../types/composer';

/**
 * Render a subheading.
 */
const Subheading = (props: HeaderProps) => {
  const {
    theme = 'transparent',
    text,
    textProps,
    topHeader,
    alignment,
    textColor,
    fontSize = 'default',
    isWordPressBlock = false,
  } = props;

  const themeTextColor = getTextColor(theme);
  const textColorClass = textColor || textColorClassMap[themeTextColor];
  const textSizeClass =
    topHeader && !isWordPressBlock
      ? 'text-2xl font-bold'
      : 'text-lg font-semibold';

  const hasTextSize =
    /\btext-(xs|sm|base|lg|xl|2xl|3xl|4xl|5xl|6xl|7xl|8xl|9xl)\b/.test(
      textProps || '',
    );

  // render regular p tag if a wordpress block so it doesn't get the default styling for P from tailwind-ui.
  const Comp: React.ElementType = isWordPressBlock ? 'p' : P;
  return (
    <Comp
      className={clsx(
        textColorClass,
        alignment && `text-${alignment}`,
        !hasTextSize && !isWordPressBlock && textSizeClass,
        textProps,
        fontSize !== 'default' && fontSize,
        isWordPressBlock && 'mt-6 max-w-[662px]',
      )}
      data-testid="subheading"
    >
      {text}
    </Comp>
  );
};

export default Subheading;
